import {
    Box,
    TextField,
    Button,
    Chip,
    Typography,
    IconButton,
    Snackbar,
    Tabs,
    Tab,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { io } from "socket.io-client";
import { Close } from "@mui/icons-material";
import Cookies from "js-cookie";
import AddNumber from "./AddNumber";
import GroupAdd from "./GroupAdd";

const baseUrl =
    "http://api.virtualprachar.com/api/whatsapp/personal/whatsapp_queue";

const WADashboard = ({ userId, whatsAppLogout }) => {
    const [open, setOpen] = useState(false);
    const [contacts, setContacts] = useState([]);
    const [isAddNum, setIsAddNum] = useState(true);
    const [msg, setMsg] = useState("");

    const [userPhoneNumber, setUserPhoneNumber] = useState(
        JSON.parse(localStorage.getItem("userPhone"))
    );
    // const [userPhoneNumber, setUserPhoneNumber] = useState("919999999999");
    useEffect(() => {
        //   socket.on("qr", (qrCodeData) => {
        //     console.log("QR Code received");

        //   });
        console.log(userPhoneNumber);
        // socket.on("connected", () => {
        //     console.log("connected to whatsapp");
        //     // navigate("dashboard");
        // });

        // return () => {
        //     socket.off("connected");
        // };
    }, []);

    const handleClose = () => {
        setOpen(false);
    };

    const action = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
            >
                <Close fontSize="small" />
            </IconButton>
        </React.Fragment>
    );

    const handleImportContacts = async () => {
        try {
            const res = await axios.get(`${baseUrl}/get-contacts`);
            console.log(res.data.contacts);

            const phoneNumbers = res.data.contacts.filter(
                (obj) => obj.phoneNumber.length === 12
            );
            const phoneNumberArr = phoneNumbers.map((obj) => {
                return { phoneNumber: obj.phoneNumber, name: obj.name };
            });
            console.log(phoneNumberArr);
            // setPhoneNumber(phoneNumberArr);
            setContacts(phoneNumberArr);
        } catch (e) {
            console.log("Error: ", e);
        }
    };

    const handleLogout = async () => {
        localStorage.removeItem("session");
        try {
            // const res = await axios.post(`${baseUrl}/logout`);
            whatsAppLogout();
        } catch (e) {
            console.log("Error: ", e);
        }
    };

    return (
        <Box
            sx={{
                // py: 1,
                display: "flex",
                textAlign: "center",
                position: "relative",
                height: "100%",
                // backgroundColor: "yellow",
                "@media(max-width:768px)": {
                    // marginTop: '3rem',
                    flexDirection: "column",
                    marginRight: "auto",
                    marginLeft: "auto",
                    // marginRight: -2,
                },
            }}
        >
            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                open={open}
                autoHideDuration={10000}
                onClose={handleClose}
                message={msg}
                action={action}
            />
            {/* Phone input and add button */}

            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    height: "100%",
                    justifyContent: "start",
                    // backgroundColor: "orange",
                    alignItems: "start",
                    // borderRight: 1,
                    // borderColor: "gray",

                    margin: 4,

                    gap: 3,
                    mb: 2,
                    "@media(max-width:768px)": {
                        flexDirection: "column",
                        marginRight: "auto",
                        marginLeft: "auto",
                        borderRight: 0,
                        paddingBottom: "1rem",
                        borderBottom: 1,
                    },
                }}
            >
                <Box
                    sx={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: "20px",
                            textAlign: "start",

                            "@media(max-width:768px)": {
                                fontSize: "14px",
                            },
                        }}
                    >
                        Logged in with : +{userPhoneNumber || ""} &nbsp;
                    </Typography>

                    {isAddNum ? <AddNumber /> : <GroupAdd />}
                </Box>
            </Box>
        </Box>
    );
};

export default WADashboard;
